import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { AdvanceFilter, StoreFilterParams } from '../../common/types'
import { defaultPageParams } from '../constants'

const defaultParams: any[] = [
  // { title: 'Status', slug: 'status', isChecked: false },
  // {
  //   title: 'Accreditation Status',
  //   slug: 'accreditation_status',
  //   isChecked: false,
  // },
]

export const useAccreditationFilterStore =
  create<AccreditationFilterstoreType>()(
    persist(
      (set) => ({
        pageParams: {
          ...defaultPageParams,
          filters: {
            is_active_application: true,
          },
          filterProps: {
            is_active_application: true,
          },
        },
        advanceFilter: {
          filterParams: defaultParams,
          isDetailed: false,
        },
        selectedRows: [],

        setAdvanceFilter: (data) => set(() => ({ advanceFilter: data })),
        clearSelectedRows: () => set({ selectedRows: [] }),
        setPageParams: (data) => set(() => ({ pageParams: data })),
        clearAdvanceFilter: () =>
          set(() => ({
            advanceFilter: {
              filterParams: defaultParams?.map((item) => ({
                ...item,
                isChecked: false,
              })),
              isDetailed: false,
            },
          })),
        setSelectedRows: (data) => set(() => ({ selectedRows: data })),
        clearAccreditationFilter: (key) =>
          set((state) => ({
            pageParams: key
              ? {
                  ...defaultPageParams,
                  search: state?.pageParams?.search,
                }
              : defaultPageParams,
          })),
        resetStore: () =>
          set(() => ({
            pageParams: {
              ...defaultPageParams,
            },
            advanceFilter: {
              filterParams: defaultParams,
              isDetailed: false,
            },
            selectedRows: [],
            search: '',
          })),
      }),
      { name: 'filt_accred_store' }
    )
  )

type AccreditationFilterstoreType = {
  pageParams: StoreFilterParams
  selectedRows?: (number | string)[]
  advanceFilter: AdvanceFilter
  setSelectedRows: (data: (number | string)[]) => void
  setPageParams: (data: StoreFilterParams) => void
  setAdvanceFilter: (data: AdvanceFilter) => void
  clearAccreditationFilter: (key?: string) => void
  clearSelectedRows: () => void
  clearAdvanceFilter: () => void
  resetStore: () => void
}
